import { Icon, IconButton } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import GlobalSearchSheet from "~/layout/mobile/GlobalSearchSheet";

const MobileSearchLauncher = () => {
	const { t } = useTranslation("common");
	const [open, setOpen] = useState(false);

	return (
		<>
			<IconButton aria-label={t("search.mobile.openAria")} onClick={() => setOpen(true)} sx={{ flexShrink: 0 }}>
				<Icon>search</Icon>
			</IconButton>
			<GlobalSearchSheet onClose={() => setOpen(false)} open={open} />
		</>
	);
};

export default MobileSearchLauncher;
